<template lang="pug">
#staff_care
  .container.custom_container_lg
    .row
      breadcrumb
  section.container.custom_container_md.custom_container_news_sm
    .row.i_mt_14.i_mt_md_10
      .col-12.text-center.text-lg-left
        h2.title.bottom_line {{ employeeCare.area01_Title }}
    .row
      .col-12.col-md-6.i_mt_10.i_mt_sm_0(
        v-for="(care, index) in careList",
        :key="index"
      )
        card(:info="care")
  section.container.custom_container_md.custom_container_news_sm
    .row.i_mt_14.i_mt_md_10
      .col-12.text-center.text-lg-left
        h2.title.bottom_line 熱情的員工參與
    .row
      .col-12.i_mt_10.i_mt_sm_8(
        v-for="(event, index) in currentNewsList",
        :key="index"
      )
        list-item(:info="event")
    .row.i_mt_8
      .col-12.text.center.justify-content-center
        b-pagination(
          v-model="currentPage",
          :total-rows="totalRows",
          :per-page="perPage",
          first-number,
          last-number
        )
</template>

<script>
import Card from "@/components/about_us/social_responsibility/Card";
import ListItem from "@/components/about_us/social_responsibility/ListItem";
import { getEmployeeCare, getEmployeeCareNews } from "@/json/about_us";
import Breadcrumb from "@/components/common/Breadcrumb";

export default {
  name: "AboutUsSocialResponsibilityStaffCard",
  metaInfo() {
    return {
      title: this.employeeCare.SEO_Title,
      meta: [
        { name: "description", content: this.employeeCare.SEO_Description },
      ],
    };
  },
  components: {
    card: Card,
    breadcrumb: Breadcrumb,
    "list-item": ListItem,
  },
  data() {
    return {
      employeeCare: {},
      careList: [],
      news: {},
      currentNewsList: [],
      totalRows: 0,
      perPage: 5,
      currentPage: 1,
    };
  },
  watch: {
    currentPage() {
      this.getCurrentList();
    },
  },
  created() {
    this.getEmployeeCare();
    this.getEmployeeCareNews();
  },
  methods: {
    getEmployeeCare() {
      getEmployeeCare().then((response) => {
        this.employeeCare = response.data;

        this.careList = [];
        let tempCare1 = {
          title: this.employeeCare.area01_SubTitle01,
          img: this.employeeCare.area01_Icon01,
          description: this.employeeCare.area01_Content01,
        };
        this.careList.push(tempCare1);
        let tempCare2 = {
          title: this.employeeCare.area01_SubTitle02,
          img: this.employeeCare.area01_Icon02,
          description: this.employeeCare.area01_Content02,
        };
        this.careList.push(tempCare2);
        let tempCare3 = {
          title: this.employeeCare.area01_SubTitle03,
          img: this.employeeCare.area01_Icon03,
          description: this.employeeCare.area01_Content03,
        };
        this.careList.push(tempCare3);
        let tempCare4 = {
          title: this.employeeCare.area01_SubTitle04,
          img: this.employeeCare.area01_Icon04,
          description: this.employeeCare.area01_Content04,
        };
        this.careList.push(tempCare4);
      });
    },
    getEmployeeCareNews() {
      getEmployeeCareNews().then((response) => {
        this.news = response.data;
        this.totalRows = this.news.EmployeeCareNewsList.length;
        this.getCurrentList();
      });
    },
    getCurrentList() {
      this.currentNewsList = [];
      let number = this.perPage * this.currentPage;
      this.currentNewsList = this.news.EmployeeCareNewsList.slice(
        number - this.perPage,
        number
      );
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/common/pagination";
@import "@/assets/style/about_us/social_responsibility/common";
@import "@/assets/style/about_us/news";
</style>
